/* eslint-disable import/no-anonymous-default-export */
import ConfirmationNew from './ConfirmationDialognew';
import { createConfirmation } from 'react-confirm';

export const confirmnew = createConfirmation(ConfirmationNew);

export default function confirmWrapper(confirmation, options = {}) {
  return confirmnew({ confirmation, ...options });
}
